import React from 'react';
import'./Footer.css'
const Footer = () => {
    return (
        <div className="footer">
            <div className="row">
                <div className="col-md-4 pt-2">
                    <h5>Our Clubs</h5>
                    <p>English Learning Club</p>
                    <p> Cooking Club</p>
                    <p> Art Learning Club</p>
                    <p>Chess Learning Club</p>
                </div>
                <div className="col-md-4 pt-2">
                    <h5>About</h5>
                    <p>A kids club, children's club or mini club is a childcare facility (daycare), which includes a fully staffed mini playground or complete village specially designed for children; is usually offered </p>
                </div>
                <div className="col-md-4 pt-2">
                    <h4>Contract</h4>
                    <p>Email: children.club@gmail.com</p>
                    <p>Phone: +8801754545654</p>
                    <p>Tlephone: 8565644</p>
                </div>
            </div>
            <p>© 2005-2021 Plagiarism Today All Rights Reserved</p>
        </div>
    );
};

export default Footer;